import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=52c2a1fa"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports